import { Pipe, PipeTransform } from '@angular/core';
import {TruncateUtil} from '../../../../utils/truncate-util';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, length: number): string {
    return TruncateUtil.truncate(value, length);
  }

}
